import {LOGIN,LOGOUT,PASSWROD_RESET_MODE,AUTHENTICATION_SUCCESS,AUTHENTICATE,AUTHENTICATION_FAILED,RESET_PASSWORD,PASSWORD_RESET_ERROR,ACCOUNT_UPDATED,PASSWORD_RESET_REQUEST_SUCCESS,PASSWORD_RESET_REQUEST_ERROR, LOAN_UPDATED,USER_ACCOUNT_UPDATED} from '../actions/types';
import Auth from '../api/auth';

export function userAccountUpdated(account)
{
    return function(dispatch)
    {
        Auth.logout();
        dispatch(
            {
                type:USER_ACCOUNT_UPDATED,
                payload:account
            })
    }
}
export function logout()
{
    return function(dispatch)
    {
        Auth.logout();
        dispatch(
            {
                type:LOGOUT,
                payload:null
            })
    }
}
export function loanUpdated()
{
    return function(dispatch)
    {
        dispatch(
            {
                type:LOAN_UPDATED,
                payload:null
            })
    }
}
export function login()
{
    return function(dispatch)
    {
        dispatch(
            {
                type:LOGIN,
                payload:null
            })
    }
}
export function authenticating()
{
    return function(dispatch)
    {
        dispatch(
            {
                type:AUTHENTICATE,
                payload:null
            })
    }
}
export function updateAccount(firstname,lastname,email,mi)
{
    return function(dispatch)
    {
        dispatch(
            {
                type:ACCOUNT_UPDATED,
                payload:{firstname,lastname,email,mi}
            })
    }
}

export function authenticate(email,password) {
    return async function(dispatch) {
        try {
            const account = await Auth.login(email, password);
            dispatch({
                type:AUTHENTICATION_SUCCESS,
                payload:account
            });
        } catch (error) {
            dispatch({
                type:AUTHENTICATION_FAILED,
                payload:error
            })
        }
    }
}

export function verifyAuthentication() {
    return function (dispatch) {
        Auth.authenticate().then(account => {
            dispatch(
                {
                    type: AUTHENTICATION_SUCCESS,
                    payload: account
                })
        }).catch(error => dispatch(
            {
                type: LOGIN,
                payload: null
            }));

    }
}
export function resettingPassword()
{
    return function(dispatch)
    {
        dispatch(
            {
                type:PASSWROD_RESET_MODE,
                payload:null
            })
    }
}
export function passwordReset()
{
    return function(dispatch)
    {
        dispatch(
            {
                type:RESET_PASSWORD,
                payload:null
            })
    }
}
export function requestPasswordReset(email)
{
    return function(dispatch)
    {
        Auth.requestPasswordReset(email).then(success=>
            {
                dispatch(
                    {
                        type:PASSWORD_RESET_REQUEST_SUCCESS,
                        payload:success
                    })
            },error=>{
                dispatch(
                    {
                        type:PASSWORD_RESET_REQUEST_ERROR,
                        payload:null
                    })
            }).catch(error=>{
                dispatch(
                    {
                        type:PASSWORD_RESET_ERROR,
                        payload:null
                    })
            })
        
    }
}